import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { ConfigService } from './config.service';
import { BaseHttpService } from './base-http.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class OAuthService extends BaseHttpService {
  getSmartRecruitersRedirectURI(): Observable<any> {
    return this.get('ats-providers-auth/sr-redirect-uri');
  }

  validateICIMSRedirectURI(): Observable<any> {
    return this.get('ats-providers-auth/icims-redirect-callback');
  }

  checkSmartRecruitersAuth(): Observable<any> {
    return this.get('ats-providers-auth/sr-confirm-auth');
  }

  checkICIMSAuth(): Observable<any> {
    return this.get('ats-providers-auth/icims-confirm-auth');
  }

  getGreenhouseRedirectURI(): Observable<any> {
    return this.get('ats-providers-auth/gh-redirect-uri');
  }

  checkGreenhouseAuth(): Observable<any> {
    return this.get('ats-providers-auth/gh-confirm-auth');
  }

  getClientHash(): Observable<any> {
    return this.get('ats-providers-auth/get-client-hash');
  }

  sendTestSlackMessage(email: string): Observable<any> {
    return this.post('ats-providers-auth/send-test-slack-message', { email });
  }

  sendTestTeamsMessage(email: string): Observable<any> {
    return this.post('ats-providers-auth/send-test-teams-message', { email });
  }

  sendTeamsWelcomeMessage(email: string): Observable<any> {
    return this.post('ats-providers-auth/send-teams-welcome-message', { email });
  }

}
